import { Flex, Menu, MenuProps } from "antd";
import { AccountBookOutlined, CommentOutlined, DashboardOutlined, RadarChartOutlined, RobotOutlined, FileOutlined, MessageOutlined, NotificationOutlined, SettingOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import React from "react";
import { UserAuth } from "../../../middleware/UserContext/UserContext.middleware";
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from "../../hooks/useCurrentUser";

import "./Sidebar.styles.css";

export const useMenuItems = () => {
  const { t } = useTranslation();
  const { isAdmin } = useCurrentUser();

  const items = [
    { key: "adverts", icon: <FileOutlined />, label: t('menu-adverts', { ns: 'navigation' }), target: "/adverts", className: "menu-item" },
    { key: "telegram_accounts", icon: <MessageOutlined />, label: t('menu-telegram', { ns: 'navigation' }), target: "/telegram_accounts", className: "menu-item" },
  ];

  if (isAdmin) {
    items.push({ key: "leads", icon: <NotificationOutlined />, label: t('menu-leads', { ns: 'navigation' }), target: "/leads", className: "menu-item" });
    items.push({ key: "admin_channels", icon: <SettingOutlined />, label: t('menu-admin-channels', { ns: 'navigation' }), target: "/admin/channels", className: "menu-item" });
    items.push({ key: "admin_deliveries", icon: <DashboardOutlined />, label: t('menu-admin-deliveries', { ns: 'navigation' }), target: "/admin/deliveries", className: "menu-item" });
    items.push({ key: "admin_crawlers", icon: <RobotOutlined />, label: t('menu-admin-crawlers', { ns: 'navigation' }), target: "/admin/crawlers", className: "menu-item" });
    items.push({ key: "admin_messenger", icon: <CommentOutlined />, label: t('menu-admin-messenger', { ns: 'navigation' }), target: "/admin/messenger", className: "menu-item" });
    items.push({ key: "admin_discovered_channels", icon: <RadarChartOutlined />, label: t('menu-admin-discovered-channels', { ns: 'navigation' }), target: "/admin/discovered-channels", className: "menu-item" });
  }

  return items;
};

export const useMenuNavigation = () => {
  const navigate = useNavigate();
  const menuItems = useMenuItems();

  const handleMenuClick: MenuProps["onClick"] = ({ key }: { key: string }) => {
    const { target } = menuItems.find((item) => item.key === key) || {};
    if (target) {
      navigate(target);
    }
  };

  return { handleMenuClick, menuItems };
};

const Sidebar: React.FC = () => {
  const { currentUser } = UserAuth();
  const { handleMenuClick, menuItems } = useMenuNavigation();

  return (
    <>
      <Flex align="center" justify="center">
        <div className="logo">
          <AccountBookOutlined />
        </div>
      </Flex>

      <Menu
        mode="inline"
        defaultSelectedKeys={["1"]}
        className="menu-bar"
        items={currentUser && menuItems}
        onClick={handleMenuClick}
      />
    </>
  );
};

export default Sidebar;